import SectionCompleted from './SectionCompleted'
import './SectionCompleted.scss'

export default SectionCompleted
